import AxiosStatic from "axios";
class ThinkificService {
  $http = AxiosStatic

  async getLink() {
    return this.$http.get("/api/Thinkific/GetLink")
      .catch(this.formatErrorsAndRethrow);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private formatErrorsAndRethrow(error: any) {
    if (error.response) {
      let err = error.response.data;
      if (err.errors) {
        err = [...Object.keys(error.response.data.errors).map(
          key => error.response.data.errors[key]
        )];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        err = err.reduce((flat: any, list: any) => flat.concat(list));
        console.log(err);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        err = err.reduce((val: any, arr: any) => `${val} \r\n${arr}`, "")
      }
      throw new Error(err);
    }
    else {
      throw new Error("An unexpected error has occurred");
    }
  }
}
export default new ThinkificService()
